import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import itLocale from 'date-fns/locale/it';

const dateFormat = 'dd-MM-yyyy';

const styles = (theme) => ({
  mainContainer: {},
  title: {
    fontSize: 25,
    fontWeight: 500,
    lineHeight: 1.6,
  },
  pickerLabel: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  pickerLabel2: {
    display: 'flex',
    justifyContent: 'space-evenly',
    marginLeft: 75,
  },
  labelStyle: {
    fontSize: 20,
  },
  labelPartRight: {
    justifyContent: 'center',
    display: 'flex',
    marginRight: 50,
  },
  labelPartLeft: {
    justifyContent: 'center',
    display: 'flex',
    marginLeft: 50,
  },
});

class OrarioStraordinarioComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: true,
      orarioDiInizio: null,
      orarioDiFine: null,
      dataInizio: this.props.dataInizio,
      dataFine: this.props.dataFine,
      mode: this.props.mode,
      apertura: this.props.aperto,
    };
  }

  handleDataInizio(data) {
    this.props.handleDataInizio(data);
  }

  handleDataFine(data) {
    this.props.handleDataFine(data);
  }

  handleOrarioInizio(data) {
    this.props.handleOrarioInizio(data);
  }

  handleOrarioFine(data) {
    this.props.handleOrarioFine(data);
  }

  handleInteraGiornata(data) {
    this.props.handleInteraGiornata(data);
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.mainContainer}>
        {this.props.mode === 'SPECIFICO' && this.state.apertura === false && (
          <>
            <div className={classes.title}>Orario:</div>
            <div>
              <FormControlLabel
                label="Esercizio chiuso per l'intera giornata"
                control={
                  <Checkbox
                    color="primary"
                    checked={this.state.checked}
                    onClick={() => {
                      this.setState({
                        checked: !this.state.checked,
                      });
                      this.handleInteraGiornata(!this.state.checked);
                    }}
                  />
                }
              />
            </div>
            <div className={classes.pickerLabel}>
              <div className={classes.labelStyle}>Chiuso dalle</div>
              <TimePicker
                ampm={false}
                minutesStep={5}
                disabled={this.state.checked}
                onChange={(newOrarioInizio) => {
                  this.setState({
                    orarioDiInizio: newOrarioInizio,
                  });
                  this.handleOrarioInizio(newOrarioInizio);
                }}
                value={this.state.orarioDiInizio}
              />
            </div>
            <div className={classes.pickerLabel2}>
              <div className={classes.labelStyle}>Alle</div>
              <TimePicker
                ampm={false}
                minutesStep={5}
                disabled={this.state.checked}
                onChange={(newOrarioFine) => {
                  this.setState({
                    orarioDiFine: newOrarioFine,
                  });
                  this.handleOrarioFine(newOrarioFine);
                }}
                value={this.state.orarioDiFine}
              />
            </div>
          </>
        )}
        {this.props.mode === 'SPECIFICO' && this.state.apertura === true && (
          <>
            <div className={classes.title}>Orario:</div>
            <div>
              <FormControlLabel
                label="Esercizio aperto per l'intera giornata"
                control={
                  <Checkbox
                    color="primary"
                    checked={this.state.checked}
                    onClick={() => {
                      this.setState({
                        checked: !this.state.checked,
                      });
                      this.handleInteraGiornata(!this.state.checked);
                    }}
                  />
                }
              />
            </div>
            <div className={classes.pickerLabel}>
              <div className={classes.labelStyle}>Aperto dalle</div>
              <TimePicker
                ampm={false}
                minutesStep={5}
                disabled={this.state.checked}
                onChange={(newOrarioInizio) => {
                  this.setState({
                    orarioDiInizio: newOrarioInizio,
                  });
                  this.handleOrarioInizio(newOrarioInizio);
                }}
                value={this.state.orarioDiInizio}
              />
            </div>
            <div className={classes.pickerLabel2}>
              <div className={classes.labelStyle}>Alle</div>
              <TimePicker
                ampm={false}
                minutesStep={5}
                disabled={this.state.checked}
                onChange={(newOrarioFine) => {
                  this.setState({
                    orarioDiFine: newOrarioFine,
                  });
                  this.handleOrarioFine(newOrarioFine);
                }}
                value={this.state.orarioDiFine}
              />
            </div>
          </>
        )}
        {this.props.mode === 'PERIODO' && this.state.apertura === false && (
          <>
            <div className={classes.title}>Orario:</div>
            <div>
              <FormControlLabel
                label="Esercizio chiuso per l'intera giornata"
                control={
                  <Checkbox
                    color="primary"
                    checked={this.state.checked}
                    onClick={() => {
                      this.setState({
                        checked: !this.state.checked,
                      });
                      this.handleInteraGiornata(!this.state.checked);
                    }}
                  />
                }
              />
            </div>
            <div className={classes.pickerLabel}>
              <div className={classes.labelPartRight}>
                <div className={classes.labelStyle}>Chiuso dalle</div>
                <div style={{ marginLeft: 40 }}>
                  <TimePicker
                    ampm={false}
                    minutesStep={5}
                    disabled={this.state.checked}
                    onChange={(newOrarioInizio) => {
                      this.setState({
                        orarioDiInizio: newOrarioInizio,
                      });
                      this.handleOrarioInizio(newOrarioInizio);
                    }}
                    value={this.state.orarioDiInizio}
                  />
                </div>
              </div>
              <div className={classes.labelPartLeft}>
                <div className={classes.labelStyle}>Del giorno</div>
                <div style={{ marginLeft: 63 }}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={itLocale}
                  >
                    <DatePicker
                      onChange={(data) => {
                        this.setState({
                          dataInizio: data,
                        });
                        this.handleDataInizio(data);
                      }}
                      disabled={false}
                      format={dateFormat}
                      value={this.state.dataInizio}
                    ></DatePicker>
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>
            <div className={classes.pickerLabel2}>
              <div className={classes.labelPartRight}>
                <div className={classes.labelStyle}>Alle</div>
                <div style={{ marginLeft: 40 }}>
                  <TimePicker
                    ampm={false}
                    minutesStep={5}
                    disabled={this.state.checked}
                    onChange={(newOrarioFine) => {
                      this.setState({
                        orarioDiFine: newOrarioFine,
                      });
                      this.handleOrarioFine(newOrarioFine);
                    }}
                    value={this.state.orarioDiFine}
                  ></TimePicker>
                </div>
              </div>
              <div className={classes.labelPartLeft}>
                <div className={classes.labelStyle}>Del giorno</div>
                <div style={{ marginLeft: 63 }}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={itLocale}
                  >
                    <DatePicker
                      onChange={(data) => {
                        this.setState({
                          dataFine: data,
                        });
                        this.handleDataFine(data);
                      }}
                      format={dateFormat}
                      disabled={false}
                      value={this.state.dataFine}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>
          </>
        )}
        {this.props.mode === 'PERIODO' && this.state.apertura === true && (
          <>
            <div className={classes.title}>Orario:</div>
            <div>
              <FormControlLabel
                label="Esercizio aperto per l'intera giornata"
                control={
                  <Checkbox
                    color="primary"
                    checked={this.state.checked}
                    onClick={() => {
                      this.setState({
                        checked: !this.state.checked,
                      });
                      this.handleInteraGiornata(!this.state.checked);
                    }}
                  />
                }
              />
            </div>
            <div className={classes.pickerLabel}>
              <div className={classes.labelPartRight}>
                <div className={classes.labelStyle}>Aperto dalle</div>
                <div style={{ marginLeft: 40 }}>
                  <TimePicker
                    ampm={false}
                    minutesStep={5}
                    disabled={this.state.checked}
                    onChange={(newOrarioInizio) => {
                      this.setState({
                        orarioDiInizio: newOrarioInizio,
                      });
                      this.handleOrarioInizio(newOrarioInizio);
                    }}
                    value={this.state.orarioDiInizio}
                  ></TimePicker>
                </div>
              </div>
              <div className={classes.labelPartLeft}>
                <div className={classes.labelStyle}>Del giorno</div>
                <div style={{ marginLeft: 63 }}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={itLocale}
                  >
                    <DatePicker
                      onChange={(data) => {
                        this.setState({
                          dataInizio: data,
                        });
                        this.handleDataInizio(data);
                      }}
                      disabled={false}
                      value={this.state.dataInizio}
                      format={dateFormat}
                    ></DatePicker>
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>
            <div className={classes.pickerLabel2}>
              <div className={classes.labelPartRight}>
                <div className={classes.labelStyle}>Alle</div>
                <div style={{ marginLeft: 40 }}>
                  <TimePicker
                    ampm={false}
                    minutesStep={5}
                    disabled={this.state.checked}
                    onChange={(newOrarioFine) => {
                      this.setState({
                        orarioDiFine: newOrarioFine,
                      });
                      this.handleOrarioFine(newOrarioFine);
                    }}
                    value={this.state.orarioDiFine}
                  />
                </div>
              </div>
              <div className={classes.labelPartLeft}>
                <div className={classes.labelStyle}>Del giorno</div>
                <div style={{ marginLeft: 63 }}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={itLocale}
                  >
                    <DatePicker
                      onChange={(data) => {
                        this.setState({
                          dataFine: data,
                        });
                        this.handleDataFine(data);
                      }}
                      disabled={false}
                      value={this.state.dataFine}
                      format={dateFormat}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>
          </>
        )}
        {this.props.mode === 'ORARIO' && this.state.apertura === false && (
          <>
            <div className={classes.title}>Orario:</div>
            <div>
              <FormControlLabel
                label="Esercizio chiuso per l'intera giornata"
                control={
                  <Checkbox
                    color="primary"
                    checked={this.state.checked}
                    onClick={() => {
                      this.setState({
                        checked: !this.state.checked,
                      });
                      this.handleInteraGiornata(!this.state.checked);
                    }}
                  />
                }
              />
            </div>
            <div className={classes.pickerLabel}>
              <div className={classes.labelStyle}>Chiuso dalle</div>
              <TimePicker
                ampm={false}
                minutesStep={5}
                disabled={this.state.checked}
                onChange={(newOrarioInizio) => {
                  this.setState({
                    orarioDiInizio: newOrarioInizio,
                  });
                  this.handleOrarioInizio(newOrarioInizio);
                }}
                value={this.state.orarioDiInizio}
              />
            </div>
            <div className={classes.pickerLabel2}>
              <div className={classes.labelStyle}>Alle</div>
              <TimePicker
                ampm={false}
                minutesStep={5}
                disabled={this.state.checked}
                onChange={(newOrarioFine) => {
                  this.setState({
                    orarioDiFine: newOrarioFine,
                  });
                  this.handleOrarioFine(newOrarioFine);
                }}
                value={this.state.orarioDiFine}
              />
            </div>
          </>
        )}
        {this.props.mode === 'ORARIO' && this.state.apertura === true && (
          <>
            <div className={classes.title}>Orario:</div>
            <div>
              <FormControlLabel
                label="Esercizio aperto per l'intera giornata"
                control={
                  <Checkbox
                    color="primary"
                    checked={this.state.checked}
                    onClick={() => {
                      this.setState({
                        checked: !this.state.checked,
                      });
                      this.handleInteraGiornata(!this.state.checked);
                    }}
                  />
                }
              />
            </div>
            <div className={classes.pickerLabel}>
              <div className={classes.labelStyle}>Aperto dalle</div>
              <TimePicker
                ampm={false}
                minutesStep={5}
                disabled={this.state.checked}
                onChange={(newOrarioInizio) => {
                  this.setState({
                    orarioDiInizio: newOrarioInizio,
                  });
                  this.handleOrarioInizio(newOrarioInizio);
                }}
                value={this.state.orarioDiInizio}
              />
            </div>
            <div className={classes.pickerLabel2}>
              <div className={classes.labelStyle}>Alle</div>
              <TimePicker
                ampm={false}
                minutesStep={5}
                disabled={this.state.checked}
                onChange={(newOrarioFine) => {
                  this.setState({
                    orarioDiFine: newOrarioFine,
                  });
                  this.handleOrarioFine(newOrarioFine);
                }}
                value={this.state.orarioDiFine}
              />
            </div>
          </>
        )}
        {this.props.mode === 'DATAEORARIO' && this.state.apertura === false && (
          <>
            <div className={classes.title}>Orario:</div>
            <div>
              <FormControlLabel
                label="Esercizio chiuso per l'intera giornata"
                control={
                  <Checkbox
                    color="primary"
                    checked={this.state.checked}
                    onClick={() => {
                      this.setState({
                        checked: !this.state.checked,
                      });
                      this.handleInteraGiornata(!this.state.checked);
                    }}
                  />
                }
              />
            </div>
            <div className={classes.pickerLabel}>
              <div className={classes.labelPartRight}>
                <div className={classes.labelStyle}>Chiuso dalle</div>
                <div style={{ marginLeft: 40 }}>
                  <TimePicker
                    ampm={false}
                    minutesStep={5}
                    disabled={this.state.checked}
                    onChange={(newOrarioInizio) => {
                      this.setState({
                        orarioDiInizio: newOrarioInizio,
                      });
                      this.handleOrarioInizio(newOrarioInizio);
                    }}
                    value={this.state.orarioDiInizio}
                  ></TimePicker>
                </div>
              </div>
              <div className={classes.labelPartLeft}>
                <div className={classes.labelStyle}>Del giorno</div>
                <div style={{ marginLeft: 63 }}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={itLocale}
                  >
                    <DatePicker
                      onChange={(data) => {
                        this.setState({
                          dataInizio: data,
                        });
                        this.handleDataInizio(data);
                      }}
                      disabled={false}
                      format={dateFormat}
                      value={this.state.dataInizio}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>
            <div className={classes.pickerLabel2}>
              <div className={classes.labelPartRight}>
                <div className={classes.labelStyle}>Alle</div>
                <div style={{ marginLeft: 40 }}>
                  <TimePicker
                    ampm={false}
                    minutesStep={5}
                    disabled={this.state.checked}
                    onChange={(newOrarioFine) => {
                      this.setState({
                        orarioDiFine: newOrarioFine,
                      });
                      this.handleOrarioFine(newOrarioFine);
                    }}
                    value={this.state.orarioDiFine}
                  ></TimePicker>
                </div>
              </div>
              <div className={classes.labelPartLeft}>
                <div className={classes.labelStyle}>Del giorno</div>
                <div style={{ marginLeft: 63 }}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={itLocale}
                  >
                    <DatePicker
                      onChange={(data) => {
                        this.setState({
                          dataFine: data,
                        });
                        this.handleDataFine(data);
                      }}
                      disabled={false}
                      value={this.state.dataFine}
                      format={dateFormat}
                    ></DatePicker>
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>
          </>
        )}
        {this.props.mode === 'DATAEORARIO' && this.state.apertura === true && (
          <>
            <div className={classes.title}>Orario:</div>
            <div>
              <FormControlLabel
                label="Esercizio aperto per l'intera giornata"
                control={
                  <Checkbox
                    color="primary"
                    checked={this.state.checked}
                    onClick={() => {
                      this.setState({
                        checked: !this.state.checked,
                      });
                      this.handleInteraGiornata(!this.state.checked);
                    }}
                  />
                }
              />
            </div>
            <div className={classes.pickerLabel}>
              <div className={classes.labelPartRight}>
                <div className={classes.labelStyle}>Aperto dalle</div>
                <div style={{ marginLeft: 40 }}>
                  <TimePicker
                    ampm={false}
                    minutesStep={5}
                    disabled={this.state.checked}
                    onChange={(newOrarioInizio) => {
                      this.setState({
                        orarioDiInizio: newOrarioInizio,
                      });
                      this.handleOrarioInizio(newOrarioInizio);
                    }}
                    value={this.state.orarioDiInizio}
                  ></TimePicker>
                </div>
              </div>
              <div className={classes.labelPartLeft}>
                <div className={classes.labelStyle}>Del giorno</div>
                <div style={{ marginLeft: 63 }}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={itLocale}
                  >
                    <DatePicker
                      onChange={(data) => {
                        this.setState({
                          dataInizio: data,
                        });
                        this.handleDataInizio(data);
                      }}
                      disabled={false}
                      value={this.state.dataInizio}
                      format={dateFormat}
                    ></DatePicker>
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>
            <div className={classes.pickerLabel2}>
              <div className={classes.labelPartRight}>
                <div className={classes.labelStyle}>Alle</div>
                <div style={{ marginLeft: 40 }}>
                  <TimePicker
                    ampm={false}
                    minutesStep={5}
                    disabled={this.state.checked}
                    onChange={(newOrarioFine) => {
                      this.setState({
                        orarioDiFine: newOrarioFine,
                      });
                      this.handleOrarioFine(newOrarioFine);
                    }}
                    value={this.state.orarioDiFine}
                  />
                </div>
              </div>
              <div className={classes.labelPartLeft}>
                <div className={classes.labelStyle}>Del giorno</div>
                <div style={{ marginLeft: 63 }}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={itLocale}
                  >
                    <DatePicker
                      onChange={(data) => {
                        this.setState({
                          dataFine: data,
                        });
                        this.handleDataFine(data);
                      }}
                      disabled={false}
                      value={this.state.dataFine}
                      format={dateFormat}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

OrarioStraordinarioComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  dataInizio: PropTypes.instanceOf(Date),
  dataFine: PropTypes.instanceOf(Date),
  aperto: PropTypes.bool,
  handleDataInizio: PropTypes.func.isRequired,
  handleDataFine: PropTypes.func.isRequired,
  handleOrarioInizio: PropTypes.func.isRequired,
  handleOrarioFine: PropTypes.func.isRequired,
  handleInteraGiornata: PropTypes.func.isRequired,
};

export default withStyles(styles)(OrarioStraordinarioComponent);
